<template>
  <div class="unit-select-progress">

    <div class="unit-select-progress__main" ref="progressCharts">
      <ProgressChartsChart v-for="container in containers" :key="container.title+'-'+container.order"
        :container="container"
        :groupTitle="container.title"
        :location="location+'>'+container.title+'-'+container.order" />
    </div>

    <div class="unit-select-progress__summary">
      <ProgressChartsMain :courseCreditsMax="courseCreditsMax" />

      <div class="floating-credit-status" :class="[showCourseStatusBar ? 'show' : '', isReviewer ? 'reviewer-offset' : '']">
        <div class="container">
          <h5 class="floating-credit-status__title">Total unit points for course</h5>
          <span class="floating-credit-status__body" v-if="courseCreditsSelected < courseCreditsMax">
            <strong>{{ courseCreditsSelected }} / {{ courseCreditsMax }} points selected</strong> <small>(excluding duplicates)</small>
          </span>
          <span class="floating-credit-status__body" v-if="courseCreditsSelected == courseCreditsMax">
            <strong>All units selected!</strong>
          </span>
          <span class="floating-credit-status__body danger" v-if="courseCreditsSelected > courseCreditsMax">
            <i class="far fa-exclamation-circle"></i> <strong>Too many units selected!</strong>
          </span>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import VueCircle from 'vue2-circle-progress/src/index.vue'
import { mapGetters } from 'vuex'
import ProgressChartsChart from './ProgressChartsChart.vue'
import ProgressChartsMain from './ProgressChartsMain.vue'

export default {
  props: {
    containers: {
      type: Array,
      required: true
    },
    courseCreditsMax: {
      type: Number,
      required: true
    },
    location: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showCourseStatusBar: false
    }
  },
  methods: {
    onScrollStatusBar(e) {
      if (this.$refs?.progressCharts) {
        var progressChartPositionBottom = this.$refs.progressCharts.getBoundingClientRect().y + this.$refs.progressCharts.clientHeight
        if (progressChartPositionBottom < 10) {
          this.showCourseStatusBar = true
        } else {
          this.showCourseStatusBar = false
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedItemsByLocation: 'units/getSelectedCurriculumItemByLocation',
      totalCredits: 'units/getTotalCredits',
      isUnpublished: 'courses/isUnpublished',
      isReviewer: 'global/isReviewer',
    }),
    courseCreditsSelected() {
      return this.totalCredits('root', false) || 0
    }
  },
  mounted() {
    // For fixed unit select status show/hide
    document.getElementById('wrapperOuter')?.addEventListener('scroll', this.onScrollStatusBar)
  },
  beforeDestroy() {
    document.getElementById('wrapperOuter')?.removeEventListener('scroll', this.onScrollStatusBar)
  },
  components: { VueCircle, ProgressChartsChart, ProgressChartsMain }
}
</script>
